import { PureComponent } from "react";
import VideosCarouselComponent from "/components/core/videos-carousel/videos-carousel-component";
export default class VideosCarouselSegmentComponent extends PureComponent {
  render() {
    return (
      <div className="video-carousel-segment">
        <VideosCarouselComponent {...this.props} />
      </div>
    );
  }
}
